// Need to map the fields to match the ones from format-products-data-nosto.js
// Used for collections, autocomplete and search
export default (collection) => {
  console.log('collection', collection);
  const products = collection.products.edges;
  const formatted_products = [];
  products?.forEach((productNode) => {
    const product = productNode.node;
    const list_price = product?.priceRange?.maxVariantPrice?.amount ? parseFloat(product.priceRange.maxVariantPrice.amount) : 0;

    formatted_products.push({
      // original_hit: JSON.parse(JSON.stringify(product)), // Look into it if we need this later for autocomplete
      product_id: product.id.replace('gid://shopify/Product/', ''),
      name: product.title,
      description: product.description || '',
      handle: product.handle || '',
      url: product.onlineStoreUrl || '',
      price: list_price,
      price_text: String(list_price.toFixed(2)),
      list_price: list_price,
      list_price_text: String(list_price.toFixed(2)),
      price_text: String(list_price.toFixed(2)),
      image_url: product?.featuredImage?.url || '',
      alternate_image_urls: product?.images?.edges.map((img) => img.node.url) || [],
      date_published: product.publishedAt ? Date.parse(product.publishedAt) : 0,
      tags1: product.tags || [],
      custom_fields: {
        'astr-images_details': product?.astrImagesDetails?.value || '[]',
        'astr-swatches': product?.astrSwatches?.value || '[]',
      },
      skus: product?.variants?.edges.map((variantEdge) => {
        const variant = variantEdge.node;
        return {
          id: variant.id.replace('gid://shopify/ProductVariant/', ''),
          name: variant.title,
          available: variant.availableForSale,
          image_url: variant?.image?.url || '',
          price: variant?.price?.amount ? parseFloat(variant.price.amount) : 0,
          compare_at_price: variant?.compareAtPrice?.amount ? parseFloat(variant.compareAtPrice.amount) : 0,
          custom_fields: {
            'Color': variant?.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || '',
            'Size': variant?.selectedOptions?.find(opt => opt.name.toLowerCase() === 'size')?.value || '',
            'skuCode': variant?.sku || '',
            'astr-color_family': variant?.astrColorFamily?.value || '',
            'astr-online_inventory': variant?.astrOnlineInventory?.value || '',
            'astr-online_inventory_style': variant?.astrOnlineInventoryStyle?.value || '',
          },
        };
      }) || [],
    });
  });

  // console.log('products after format', formatted_products);

  return {
    products: {
      hits: formatted_products,
      facets: [],
      size: formatted_products.length,
      total: window.theme.collections.liquid_count || formatted_products.length,
    }
  };
};
